import type { NumberFormat, NumberSettings } from '../types';

const KEY_PART_SEPARATOR = '|';

/*
Ключ кеша динамических форматтеров.

Локаль в ключ не входит: кеш живёт внутри замыкания одного createNumberFormatter,
которое уже создано под конкретную локаль.

defaultFormat в ключ не входит: ни одна фабрика из numberFormatterFactories
его не читает, на собранный форматтер он не влияет.
*/
export const buildOverriddenFormatterKey = (
    format: NumberFormat,
    settings: NumberSettings,
): string => [
    format,
    settings.currency,
    settings.oddsType,
    settings.hideCurrencySymbol,
    settings.minimumFractionDigits,
    settings.maximumFractionDigits,
].join(KEY_PART_SEPARATOR);
